import { render, staticRenderFns } from "./pd-tech-specs.vue?vue&type=template&id=b2d8dc42&"
import script from "./pd-tech-specs.vue?vue&type=script&lang=js&"
export * from "./pd-tech-specs.vue?vue&type=script&lang=js&"
import style0 from "./pd-tech-specs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdPaceFeatureComparison: require('/opt/build/repo/storefront/components/legacy/product-dynamic/pd-pace-feature-comparison.vue').default})
